import { createConstants } from '../_helpers/utils'
export const alertTypes = createConstants(
    'ALERT_REQUEST',
    'ALERT_SUCCESS',
)